import React from "react";
import { Modal } from "react-bootstrap";

const FreeTrialConfirmation = (props) => {

  return (
    <Modal show={props.show} onHide={() => props.setEmailModalOpen(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Account Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: "#e8f5e9",
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="#4caf50"
              viewBox="0 0 24 24"
            >
              <path d="M9 16.2l-3.5-3.5 1.41-1.41L9 13.38l7.59-7.59L18 7.8l-9 9z" />
            </svg>
          </div>
          <p>Below are your account details:</p>
          <div
            style={{
              textAlign: "left",
              backgroundColor: "#f9f9f9",
              padding: "1rem",
              borderRadius: "8px",
              width: "100%",
              maxWidth: "450px",
              boxSizing: "border-box",
              fontFamily: "poppins",
              fontSize: "1.4rem",
              cursor: "pointer",
              transition: "background-color 0.3s ease, border-color 0.3s ease",
            }}
            onClick={() => {
              const details = `Login URL: ${process.env.REACT_APP_LOGIN_URL}\nEmail: ${props.formData.emailId}\nPassword: ${props.formData.password}`;
              navigator.clipboard.writeText(details);
              alert("Details copied to clipboard!");
            }}
          >
            <div>
              <strong>Login URL:</strong> {process.env.REACT_APP_LOGIN_URL}
            </div>
            <div>
              <strong>Email:</strong> {props.formData.emailId}
            </div>
            <div>
              <strong>Password:</strong> {props.formData.password}
            </div>
          </div>
          <button
            onClick={props.handleOkClick}
            style={{
              marginTop: "1.5rem",
              padding: "0.5rem 1.5rem",
              backgroundColor: "#6200ea",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            OK
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FreeTrialConfirmation;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/FreeTrialConfirmation.js